import { render, staticRenderFns } from "./LoadingCover.vue?vue&type=template&id=f0af6152&scoped=true&"
import script from "./LoadingCover.vue?vue&type=script&lang=js&"
export * from "./LoadingCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0af6152",
  null
  
)

export default component.exports